import { Link } from "react-router-dom";
import type { MediaItem } from "@/types";
import { CATEGORY_LABELS } from "@/types";
import { formatDate, formatViews } from "@/utils/media";

interface MediaCardProps {
  item: MediaItem;
}

export default function MediaCard({ item }: MediaCardProps) {
  return (
    <Link
      to={`/detail/${item.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
    >
      <div className="relative aspect-[3/4] w-full overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} - 羞羞影视资讯`}
          title={`${item.title} 影视资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-md bg-primary-950/80 px-2 py-1 text-xs font-medium text-background-50 backdrop-blur-sm">
          {CATEGORY_LABELS[item.category]}
        </span>
        <span className="absolute right-3 top-3 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-primary-950">
          <i className="ri-star-fill text-[10px]" aria-hidden="true" />
          {item.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-primary-950/70 to-transparent" />
        <span className="absolute bottom-3 left-3 text-xs font-medium text-background-50">
          {item.region} · {item.year}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-4">
        <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
          {item.title}
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-relaxed text-foreground-500">
          {item.summary}
        </p>
        <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line" aria-hidden="true" />
            {formatViews(item.views)}
          </span>
          <span>{formatDate(item.releaseDate)}</span>
        </div>
      </div>
    </Link>
  );
}